import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../../PricingHub/SearchComponent';

class TrialSubscriptionSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.accountType',
      name: 'accountType',
      type: 'select',
      tOptions: 'selections:accountType',
      isClearable: true,
    },
    {
      label: 'label.sellingCompany',
      name: 'sellingCompany',
    },
    // {
    //   label: 'label.initialTermUnit',
    //   name: 'initialTermUnit',
    //   tOptions: 'selections:termUnit',
    //   isClearable: true,
    // },
    // {
    //   label: 'label.renewalTermUnit',
    //   name: 'renewalTermUnit',
    //   tOptions: 'selections:termUnit',
    //   isClearable: true,
    // },
    // {
    //   label: 'label.marketSegment',
    //   name: 'marketSegment',
    //   tOptions: 'selections:marketSegment',
    //   isClearable: true,
    //   type: 'select',
    // },
    {
      label: 'label.trialType',
      name: 'trialType',
      tOptions: 'selections:trialTypes',
      isClearable: true,
      type: 'select',
    },
    {
      label: 'label.expiryDays',
      name: 'expiryDays',
      type: 'number',
    },
    // {
    //   label: 'label.status',
    //   name: 'status',
    //   tOptions: 'selections:subscriptionStatus',
    //   isClearable: true,
    //   type: 'select',
    // },
  ];

  btnSpan = 'col-md-12';
}

TrialSubscriptionSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

TrialSubscriptionSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(TrialSubscriptionSearchForm);
